<ng-container *ngIf="viewModel$ | async as viewModel">
  <div class="two-columns-container">
    <div>
      <label for="customerFullNameInput">Full Name (Required)</label>
      <input
        id="customerFullNameInput"
        type="text"
        pInputText
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [tabindex]="viewModel.tabIndices.fullName"
        [ngModel]="viewModel.fullName"
        [required]="true"
        appControlMeta="fullName"
        #fullNameModel="ngModel"
        [disabled]="!viewModel.customerEditable?.customerEditable"
        placeholder="Customer Name"
        (input)="
          store.dispatch(
            actions.fullNameInputChanged({
              value: $any($event.target).value,
            })
          )
        "
      />
      <app-validation-messages
        [control]="fullNameModel.control"
        [requireTouched]="true"
      ></app-validation-messages>
    </div>
    <div>
      <label for="customerCompanyInput">Company</label>
      <input
        id="customerCompanyInput"
        type="text"
        pInputText
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [tabindex]="viewModel.tabIndices.company"
        [ngModel]="viewModel.company"
        appControlMeta="company"
        #companyModel="ngModel"
        [disabled]="!viewModel.customerEditable?.customerEditable"
        placeholder="Company name"
        (input)="
          store.dispatch(
            actions.companyInputChanged({
              value: $any($event.target).value,
            })
          )
        "
      />
      <app-validation-messages
        [control]="companyModel.control"
        [requireTouched]="true"
      ></app-validation-messages>
    </div>
  </div>
  <div class="two-columns-container">
    <div>
      <label for="customerEmailInput">Email</label>
      <input
        id="customerEmailInput"
        type="text"
        pInputText
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [tabindex]="viewModel.tabIndices.email"
        [ngModel]="viewModel.email"
        [pattern]="emailPattern"
        appControlMeta="email"
        #emailModel="ngModel"
        [disabled]="!viewModel.customerEditable?.customerEditable"
        placeholder="john@mail.com"
        (input)="
          store.dispatch(
            actions.emailInputChanged({
              value: $any($event.target).value,
            })
          )
        "
      />
      <app-validation-messages
        [control]="emailModel.control"
        [requireTouched]="true"
      ></app-validation-messages>
    </div>
    <div>
      <label for="customerPhoneInput">Phone</label>
      <input
        id="customerPhoneInput"
        type="text"
        pInputText
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [tabindex]="viewModel.tabIndices.phone"
        [ngModel]="viewModel.phone"
        [pattern]="phonePattern"
        appControlMeta="phone"
        #phoneModel="ngModel"
        [disabled]="!viewModel.customerEditable?.customerEditable"
        placeholder="(xxx)-xxx-xxxx"
        (input)="
          store.dispatch(
            actions.phoneInputChanged({
              value: $any($event.target).value,
            })
          )
        "
      />
      <app-validation-messages
        [control]="phoneModel.control"
        [requireTouched]="true"
      ></app-validation-messages>
    </div>
  </div>
  <div *ngIf="viewModel.additionalContacts?.length">
    <label>Additional Contacts</label>
    <div
      *ngFor="let contact of viewModel.additionalContacts; let i = index; trackBy: trackByIndex"
      class="input-row"
    >
      <div class="input-area">
        <input
          type="text"
          pInputText
          [ngModel]="contact.name"
          [tabindex]="viewModel.tabIndices.additionalContacts[i].name"
          placeholder="Name"
          (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'name', value: $any($event.target).value }))"
        />
        <div>
          <input
            type="text"
            pInputText
            [ngModel]="contact.email"
            [tabindex]="viewModel.tabIndices.additionalContacts[i].email"
            placeholder="Email"
            [pattern]="emailPattern"
            #additionalEmailModel="ngModel"
            (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'email', value: $any($event.target).value }))"
          />
          <app-validation-messages
            [control]="additionalEmailModel.control"
            [requireTouched]="true"
          ></app-validation-messages>
        </div>
        <div>
          <input
            type="text"
            pInputText
            [ngModel]="contact.phone"
            [tabindex]="viewModel.tabIndices.additionalContacts[i].phone"
            placeholder="Phone"
            [pattern]="phonePattern"
            #additionalPhoneModel="ngModel"
            (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'phone', value: $any($event.target).value }))"
          />
          <app-validation-messages
            [control]="additionalPhoneModel.control"
            [requireTouched]="true"
          ></app-validation-messages>
        </div>
        <input
          type="text"
          pInputText
          [ngModel]="contact.relationship"
          [tabindex]="viewModel.tabIndices.additionalContacts[i].relationship"
          placeholder="Relationship"
          (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'relationship', value: $any($event.target).value }))"
        />
      </div>
      <button
        pButton
        class="editButton"
        icon="pi pi-times"
        [text]="true"
        (click)="store.dispatch(actions.removeAdditionalContactButtonClicked({ index: i }))"
      ></button>
    </div>
  </div>
  <div style="margin-top: 0.5rem;">
    <button
      pButton
      [text]="true"
      icon="pi pi-plus"
      label="Add Contact"
      [tabindex]="viewModel.tabIndices.addContact"
      (click)="store.dispatch(actions.addAdditionalContactButtonClicked())"
    ></button>
  </div>
  <app-new-opportunity-similar-jobs></app-new-opportunity-similar-jobs>
  <app-mr-calculator
    *ngIf="viewModel.showCalculator"
    slot="customer"
    [showHeader]="false"
  ></app-mr-calculator>
  <app-new-opportunity-search-customers-dialog></app-new-opportunity-search-customers-dialog>
  <section class="timeline-section">
    <header>
      <h2><i class="pi pi-calendar p-mr-1"></i> Timeline</h2>
    </header>
    <main>
      <div class="schedule-column">
        <app-availability-schedule></app-availability-schedule>
      </div>
      <div
        class="timeline-right-column"
        [style.maxHeight.px]="scheduleHeight || null"
      >
        <div class="availability-loading" *ngIf="viewModel.showLoadingState">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Loading availability...</span>
        </div>
        <div class="availability-empty-state" *ngIf="viewModel.showEmptyState">
          <i class="pi pi-calendar-clock"></i>
          <span>Select dates to view availability.</span>
        </div>
        <ng-container *ngIf="viewModel.showAvailabilityDates">
          <app-availability-date
            *ngFor="let date of viewModel.availabilityDates"
            [date]="date"
          ></app-availability-date>
        </ng-container>
      </div>
    </main>
  </section>
  <div class="two-columns-container">
    <div>
      <label for="JobTypeDropdown">Job Type</label>
      <p-dropdown
        [options]="jobCategories"
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [disabled]="true"
        id="JobTypeDropdown"
      ></p-dropdown>
    </div>
    <div>
      <label for="customerTypeDropdown">Customer Type</label>
      <p-dropdown
        [ngModel]="viewModel.customerType"
        [options]="viewModel.customerTypeOptions"
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [tabindex]="viewModel.tabIndices.customerType"
        [showClear]="true"
        (onChange)="
          store.dispatch(
            actions.customerTypeSelected({ customerType: $event.value })
          )
        "
        id="customerTypeDropdown"
      ></p-dropdown>
    </div>
  </div>
  <div class="two-columns-container">
    <div>
      <label for="howHeardDropdown"
        >How did they hear about us?
        {{ viewModel.howHeardMandatory ? '(Required)' : '' }}</label
      >
      <app-source-tree-select
        #howHeardModel="ngModel"
        [ngModel]="viewModel.referralSource || null"
        [options]="viewModel.howHeardDropdownOptions"
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [required]="viewModel.howHeardMandatory"
        [tabindex]="viewModel.tabIndices.howHeard"
        (valueChange)="
          store.dispatch(
            actions.referralSourceSelected({ referralSource: $event })
          )
        "
        appControlMeta="referralSource"
        id="howHeardDropdown"
      ></app-source-tree-select>
      <app-validation-messages
        [control]="howHeardModel.control"
        [requireTouched]="true"
      ></app-validation-messages>
    </div>
    <div>
      <label for="jobOriginDropdown">How did they contact us?</label>
      <p-dropdown
        [ngModel]="viewModel.jobOrigin || null"
        [options]="viewModel.jobOriginOptions"
        [style]="{ width: '100%', marginTop: '0.5rem' }"
        [tabindex]="viewModel.tabIndices.jobOrigin"
        [showClear]="true"
        (onChange)="
          store.dispatch(actions.jobOriginSelected({ jobOrigin: $event.value }))
        "
        id="jobOriginDropdown"
      ></p-dropdown>
    </div>
  </div>
  <div class="one-column-container">
    <p-checkbox
      id="useEndLocationAsBillingLocation"
      [binary]="true"
      [tabindex]="viewModel.tabIndices.billingCheckbox"
      [ngModel]="viewModel.useEndLocationAsBillingLocation"
      (onChange)="
        store.dispatch(
          actions.useEndLocationAsBillingLocationCheckboxClicked({
            checked: $event.checked,
          })
        );
        focusBillingAddress(!$event.checked)
      "
      label="Use end location as billing location"
    ></p-checkbox>
  </div>
  <div
    class="one-column-container"
    *ngIf="!viewModel.useEndLocationAsBillingLocation"
  >
    <div class="location-inputs">
      <div class="unit-field">
        <label for="billingUnitNumber">Unit #</label>
        <input
          id="billingUnitNumber"
          type="text"
          pInputText
          [tabindex]="viewModel.tabIndices.billingUnit"
          [ngModel]="viewModel.locationEditors?.billing?.unitNumber"
          (ngModelChange)="
            store.dispatch(
              actions.unitNumberEntered({
                locationType: 'billing',
                unitNumber: $event,
              })
            )
          "
        />
      </div>
      <div class="address-field">
        <label for="billingAddress">Address</label>
        <input
          id="billingAddress"
          pInputText
          [tabindex]="viewModel.tabIndices.billingAddress"
          [ngModel]="viewModel.locationEditors?.billing?.address"
          #billingLocationAutocompleteModel="ngModel"
          ngx-gp-autocomplete
          autocomplete="off"
          (onAddressChange)="
            store.dispatch(
              actions.googleAutocompleteAddressSelected({
                address: $event,
                locationType: 'billing',
              })
            )
          "
          (input)="
            store.dispatch(
              actions.googleAutocompleteInputChanged({
                address: $event.target.value,
                locationType: 'billing',
              })
            )
          "
          [ngClass]="{
            'location-invalid':
              viewModel.billingLocationInvalid &&
              billingLocationAutocompleteModel.dirty,
          }"
        />
        <small
          *ngIf="
            viewModel.billingLocationInvalid &&
            billingLocationAutocompleteModel.dirty
          "
          class="field-error-message"
        >
          You must use autocomplete to set the location.
        </small>
      </div>
    </div>
  </div>
</ng-container>
